<template>
  <div class="form-input">
    <label class="label-input">{{ label }}</label>
    <input
      type="date"
      class="input"
      @input="changeInput"
      :value="value"
      autocomplete="off"
      :min="min"
    />
    <p :class="[hasError ? 'error' : 'no-error']">
      {{ error?.esMessage || "" }}
    </p>
    <p>{{ min }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DatePickerInput",
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: Object,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    function changeInput(event: Event) {
      const target = event.target as HTMLInputElement;

      context.emit("update:text", target.value);
    }

    return { changeInput };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/datePickerInputStyle";
</style>
